export function phoneFormatter (phone, international=false) {
  if (!phone) {return ""}
  const lineNumber = phone.slice(phone.length-4)
  const prefix = phone.slice(phone.length-7, phone.length-4)
  const areaCode = phone.slice(phone.length-10, phone.length-7)
  const countryCode = phone.slice(0, phone.length-10)
  return `${(international?countryCode+" ":"")}(${areaCode}) ${prefix}-${lineNumber}`
}